import store from '@Store';
import { updateDialog, closeDialog } from '@Containers/Dialogs/DialogsActions';

import { v4 as uuid } from 'uuid';
import BatchExecutionDetails from '@Services/BatchExecutionDetails';
import {
  typeOfBatchExecutionDetailsModal,
  batchExecutionDetailsModalSetIsLoadingReducerType,
  batchExecutionDetailsModalSetQueriesReducerType,
  batchExecutionDetailsModalSetFilenameReducerType,
  batchExecutionDetailsModalSetContextReducerType,
  batchExecutionDetailsModalSetOptionsReducerType,
  batchExecutionDetailsModalSetDetailsListReducerType,
  batchExecutionDetailsModalSetIsShowPicturesReducerType,
} from './BatchExecutionDetailsModalConstants';
import { queries as queriesSelector, filename as filenameSelector } from './BatchExecutionDetailsModalSelectors';
import { initialState } from './BatchExecutionDetailsModalReducer';

const contexts = {
  citations: 'Documents',
  reactions: 'Reactions',
  substances: 'Substances',
  tgitems: 'Targets',
};

export const openBatchExecutionDetailsModal = (props) => (dispatch) => {
  dispatch(
    updateDialog({
      id: typeOfBatchExecutionDetailsModal,
      dialogType: typeOfBatchExecutionDetailsModal,
      movable: false,
      backdrop: true,
      ...props,
    })
  );
};

export const closeBatchExecutionDetailsModal = () => (dispatch) => {
  dispatch(
    closeDialog({
      id: typeOfBatchExecutionDetailsModal,
    })
  );
};

export const dispatchOpenBatchExecutionDetailsModal = (...args) => {
  store.dispatch(openBatchExecutionDetailsModal(...args));
};

export function setIsLoading(isLoading) {
  return {
    type: batchExecutionDetailsModalSetIsLoadingReducerType,
    payload: { isLoading },
  };
}

export function setQueries(queries) {
  return {
    type: batchExecutionDetailsModalSetQueriesReducerType,
    payload: { queries },
  };
}

export function setFilename(filename) {
  return {
    type: batchExecutionDetailsModalSetFilenameReducerType,
    payload: { filename },
  };
}

export function setContext(context) {
  return {
    type: batchExecutionDetailsModalSetContextReducerType,
    payload: { context },
  };
}

export function setOptions(options) {
  return {
    type: batchExecutionDetailsModalSetOptionsReducerType,
    payload: { options },
  };
}

export function setDetailsList(detailsList) {
  return {
    type: batchExecutionDetailsModalSetDetailsListReducerType,
    payload: { detailsList },
  };
}

export function setIsShowPictures(isShowPictures) {
  return {
    type: batchExecutionDetailsModalSetIsShowPicturesReducerType,
    payload: { isShowPictures },
  };
}

export const resetState = () => (dispatch) => {
  dispatch(setQueries(initialState.get('queries')));
  dispatch(setFilename(initialState.get('filename')));
  dispatch(setContext(initialState.get('context')));
  dispatch(setOptions(initialState.get('options')));
  dispatch(setDetailsList(initialState.get('detailsList')));
  dispatch(setIsShowPictures(initialState.get('isShowPictures')));
};

export const init = (searchId, databaseId) => async (dispatch) => {
  dispatch(resetState());
  dispatch(setIsLoading(true));

  await BatchExecutionDetails.getById(searchId, databaseId)
    .then((details) => {
      if (details) {
        dispatch(setQueries(details.queries));
        dispatch(setFilename(details.filename));
        dispatch(setContext(contexts[details.context]));
        dispatch(setOptions(details.options));
        dispatch(setDetailsList(details.items));

        const isShowPictures = details.context === 'reactions' || details.context === 'substances';
        dispatch(setIsShowPictures(isShowPictures));
      }
    })
    .catch(Logger.error)
    .finally(() => {
      dispatch(setIsLoading(false));
    });
};

export const cancel = (closeCallback) => (dispatch) => {
  dispatch(setIsLoading(false));
  dispatch(closeBatchExecutionDetailsModal());
  if (closeCallback) {
    closeCallback();
  }
};

export const openQuery = (databaseId, detail) => async (dispatch, getState) => {
  const queries = queriesSelector(getState());
  if (!queries) {
    Logger.error('BatchExecutionDetailsController - queries are missing', queries);
    return;
  }
  const filename = filenameSelector(getState());

  const payload = {
    queryFactItem: queries[detail.itemNumber],
    context: detail.context,
    databases: [databaseId],
    searchId: uuid(),
  };
  const callback = () => dispatch(closeBatchExecutionDetailsModal());
  await BatchExecutionDetails.searchSingleQuery(payload, detail.itemNumber + 1, filename, callback);
};
